var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 145,
    viewBox: "0 0 186 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87,
    cy: 131,
    rx: 86,
    ry: 14,
    fill: "url(#paint0_linear_88_40002)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7924 107.163L79.6437 106.509C78.1378 99.5481 77.6009 93.8584 78.0329 89.4397C78.4649 85.021 79.6494 81.2533 81.5864 78.1368C83.5234 75.0202 86.0089 71.9894 89.0429 69.0442C90.8655 67.2536 92.4189 65.2757 93.7029 63.1105C94.9787 60.9088 95.8332 58.5162 96.2665 55.9325C96.7357 53.3406 96.6439 50.6085 95.9914 47.7362C95.1818 44.1731 93.6532 41.2704 91.4056 39.0281C89.1579 36.7859 86.4897 35.27 83.4007 34.4807C80.3117 33.6913 77.0785 33.6803 73.7008 34.4477C70.7544 35.1172 68.0561 36.3802 65.6061 38.2368C63.1561 40.0934 61.3164 42.557 60.0868 45.6275C58.8573 48.698 58.5862 52.4111 59.2735 56.7667L45.691 59.8526C44.5742 53.6064 44.9533 47.957 46.8284 42.9046C48.7394 37.8439 51.8021 33.6114 56.0165 30.2068C60.2668 26.7941 65.3025 24.4265 71.1235 23.1039C77.4476 21.6671 83.2344 21.6906 88.4838 23.1744C93.7692 24.65 98.1914 27.3159 101.75 31.172C105.345 35.0199 107.787 39.7798 109.076 45.4517C109.984 49.4511 110.195 53.2075 109.709 56.721C109.258 60.2263 108.19 63.5086 106.505 66.568C104.855 69.6193 102.672 72.4858 99.9565 75.1675C97.2488 77.8857 95.1947 80.57 93.7941 83.2205C92.3854 85.8347 91.5926 88.7486 91.4158 91.9623C91.2391 95.176 91.6269 99.0452 92.5794 103.57L92.7281 104.224L79.7924 107.163Z",
    fill: "url(#paint1_linear_88_40002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9267 124.876L99.9267 124.876L99.924 124.885C99.4251 126.491 98.5742 127.885 97.3669 129.07C96.1983 130.201 94.7647 130.963 93.0517 131.352C90.5257 131.926 88.1615 131.507 85.9295 130.083C83.6974 128.659 82.2998 126.677 81.7179 124.116C81.136 121.555 81.5403 119.164 82.938 116.916C84.3356 114.667 86.2866 113.267 88.8125 112.694C91.3385 112.12 93.7027 112.539 95.9346 113.963C98.1668 115.387 99.5643 117.368 100.146 119.929C100.531 121.624 100.457 123.27 99.9267 124.876Z",
    stroke: "url(#paint2_linear_88_40002)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3749 90.1406L54.9603 93.1199C54.6551 93.4965 54.6551 94.0356 54.9603 94.4121L57.3749 97.3914L54.3992 94.9739C54.0231 94.6683 53.4846 94.6683 53.1085 94.9739L50.1328 97.3914L52.5474 94.4121C52.8526 94.0356 52.8526 93.4965 52.5474 93.1199L50.1328 90.1406L53.1085 92.5581C53.4846 92.8637 54.0231 92.8637 54.3992 92.5581L57.3749 90.1406Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5079 93.7669L54.2609 94.2744L53.754 104.534L53.247 94.2744L43 93.7669L53.247 93.2593L53.754 83L54.2609 93.2593L64.5079 93.7669Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.375 20.1406L135.96 23.1199C135.655 23.4965 135.655 24.0356 135.96 24.4121L138.375 27.3914L135.399 24.9739C135.023 24.6683 134.485 24.6683 134.108 24.9739L131.133 27.3914L133.547 24.4121C133.853 24.0356 133.853 23.4965 133.547 23.1199L131.133 20.1406L134.108 22.5581C134.485 22.8637 135.023 22.8637 135.399 22.5581L138.375 20.1406Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.508 23.7669L135.261 24.2744L134.754 34.5337L134.247 24.2744L124 23.7669L134.247 23.2593L134.754 13L135.261 23.2593L145.508 23.7669Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.751 130.879L113.875 128L111 130.879L113.875 133.758L116.751 130.879Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16534 109.379C5.91352 109.379 7.33069 107.951 7.33069 106.189C7.33069 104.428 5.91352 103 4.16534 103C2.41717 103 1 104.428 1 106.189C1 107.951 2.41717 109.379 4.16534 109.379Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6675 4.36038C29.5885 4.36038 30.335 3.60813 30.335 2.68019C30.335 1.75225 29.5885 1 28.6675 1C27.7466 1 27 1.75225 27 2.68019C27 3.60813 27.7466 4.36038 28.6675 4.36038Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.047 96.864L168.697 93.4883L165.347 96.864L168.697 100.24L172.047 96.864Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.697 80L169.244 94.0403H168.15L168.697 80Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.697 113.65L169.244 99.6094H168.15L168.697 113.65Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.394 96.8245L171.46 96.2734V97.3755L185.394 96.8245Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152 96.8245L165.934 96.2734V97.3755L152 96.8245Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_40002",
    x1: 90.5,
    y1: 114.5,
    x2: 90.5,
    y2: 151.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D15757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_40002",
    x1: 107.667,
    y1: 14.8014,
    x2: 82.0275,
    y2: 118.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_40002",
    x1: 100.02,
    y1: 109.634,
    x2: 95.9745,
    y2: 135.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9b9e6af24faf460900d266f99c9a7235.svg";
export { ForwardRef as ReactComponent };